export const BANK_TRANSFER_DETAILS = {
  iban: 'TR41 0001 0026 1197 9585 6250 03',
  ibanCompact: 'TR410001002611979585625003',
  bankName: 'Ziraat Bankası',
  accountName: 'DC Natura Gıda Sanayi Ticaret A.Ş.',
};

const PAYMENT_METHOD_LABELS = {
  tr: {
    notSpecified: 'Belirtilmedi',
    bank_transfer: 'Havale / EFT',
    ziraat_3d: 'Kredi Kartı (Ziraat)',
    ziraat: 'Kredi Kartı (Ziraat)',
    revolut: 'Revolut',
    card: 'Kredi Kartı',
    stripe: 'Stripe',
  },
  en: {
    notSpecified: 'Not specified',
    bank_transfer: 'Bank Transfer (Wire/EFT)',
    ziraat_3d: 'Credit Card (Ziraat)',
    ziraat: 'Credit Card (Ziraat)',
    revolut: 'Revolut',
    card: 'Credit Card',
    stripe: 'Stripe',
  },
  de: {
    notSpecified: 'Nicht angegeben',
    bank_transfer: 'Banküberweisung / EFT',
    ziraat_3d: 'Kreditkarte (Ziraat)',
    ziraat: 'Kreditkarte (Ziraat)',
    revolut: 'Revolut',
    card: 'Kreditkarte',
    stripe: 'Stripe',
  },
  fr: {
    notSpecified: 'Non spécifié',
    bank_transfer: 'Virement bancaire / EFT',
    ziraat_3d: 'Carte de crédit (Ziraat)',
    ziraat: 'Carte de crédit (Ziraat)',
    revolut: 'Revolut',
    card: 'Carte de crédit',
    stripe: 'Stripe',
  },
  es: {
    notSpecified: 'No especificado',
    bank_transfer: 'Transferencia bancaria / EFT',
    ziraat_3d: 'Tarjeta de crédito (Ziraat)',
    ziraat: 'Tarjeta de crédito (Ziraat)',
    revolut: 'Revolut',
    card: 'Tarjeta de crédito',
    stripe: 'Stripe',
  },
  it: {
    notSpecified: 'Non specificato',
    bank_transfer: 'Bonifico bancario / EFT',
    ziraat_3d: 'Carta di credito (Ziraat)',
    ziraat: 'Carta di credito (Ziraat)',
    revolut: 'Revolut',
    card: 'Carta di credito',
    stripe: 'Stripe',
  },
  pt: {
    notSpecified: 'Não especificado',
    bank_transfer: 'Transferência bancária / EFT',
    ziraat_3d: 'Cartão de crédito (Ziraat)',
    ziraat: 'Cartão de crédito (Ziraat)',
    revolut: 'Revolut',
    card: 'Cartão de crédito',
    stripe: 'Stripe',
  },
  ru: {
    notSpecified: 'Не указано',
    bank_transfer: 'Банковский перевод / EFT',
    ziraat_3d: 'Кредитная карта (Ziraat)',
    ziraat: 'Кредитная карта (Ziraat)',
    revolut: 'Revolut',
    card: 'Кредитная карта',
    stripe: 'Stripe',
  },
  ar: {
    notSpecified: 'غير محدد',
    bank_transfer: 'تحويل بنكي / EFT',
    ziraat_3d: 'بطاقة ائتمان (Ziraat)',
    ziraat: 'بطاقة ائتمان (Ziraat)',
    revolut: 'Revolut',
    card: 'بطاقة ائتمان',
    stripe: 'Stripe',
  },
  zh: {
    notSpecified: '未指定',
    bank_transfer: '银行转账 / EFT',
    ziraat_3d: '信用卡 (Ziraat)',
    ziraat: '信用卡 (Ziraat)',
    revolut: 'Revolut',
    card: '信用卡',
    stripe: 'Stripe',
  },
};

export function formatPaymentMethodLabel(method, locale = 'tr') {
  const lang = (locale || 'tr').split('-')[0].toLowerCase();
  const labels = PAYMENT_METHOD_LABELS[lang] || PAYMENT_METHOD_LABELS.en;
  if (!method) return labels.notSpecified;
  const key = String(method).toLowerCase();
  return labels[key] || String(method).replace(/_/g, ' ');
}

/** Siparişte ödeme yöntemi: payment_method, yoksa provider / payment_info */
export function resolveOrderPaymentMethod(order) {
  if (!order || typeof order !== 'object') return null;
  return (
    order.payment_method
    || order.payment_provider
    || order.payment_info?.method
    || order.payment_info?.provider
    || null
  );
}
